/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../constants';
const elementName = `${COMPONENT_NAME_PREFIX}divider`;
const attributes = {
    VERTICAL: 'vertical'
};
export const DIVIDER_CONSTANTS = {
    elementName,
    attributes
};
